import get from 'lodash/get';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { parseColorsFromCmsBootstrapFormat } from 'common/entities/color/utils';
import { parseFontsFromCmsBootstrapFormat } from 'common/entities/font/utils';
import { setIsUpdating } from 'common/compounds/FormRenderer/actions';
import { getGuestAccessHash } from 'common/compounds/FormRenderer/selectors/index';

import { openModal, fetchFormRenderer, fetchFilledFormRenderer, loadBootstrapData } from './modules/splashPage';

const bootstrap = getBootstrap();

const EVENT_SUBDOMAIN = window.splash.server._event ? window.splash.server._event.domain.subdomain : '';

const CLIENT_ID = window.splash.server.constants.attendeeClientId;
const CLIENT_SECRET = window.splash.server.constants.attendeeClientSecret;
const baseApiUrl = bootstrap.get('app.splashApiUrl', false);

const modifyRegistration = bootstrap.get('splashPage.modifyRegistration', false);
const updatingRegistrationActive = bootstrap.get('splashPage.updatingRegistrationActive', false);
const guestAccessHash = bootstrap.get('splashPage.guestAccessHash', null);
const isInsideEditingFrame = bootstrap.get('splashPage.insideEditingIframe', false);
const limitOneOrderPerEmail = bootstrap.get('splashPage.limitOneOrderPerEmail', false);
const limitOneTicketTypePerEmail = bootstrap.get('splashPage.limitOneTicketTypePerEmail', false);
const isUnpublished = bootstrap.get('splashPage.isUnpublished', false);
const isFormSessionRegistrationFlagEnabled = bootstrap.get('flags.formRegistrationForm', false);

const viewerData = get(window, 'constants.viewer', null);

/**
 * @return {string} - returns the protocol of the current URL, including the colon (:).
 */
const getProtocol = () => window.location.protocol || 'https:';

/**
 * @return {boolean} - returns true/false based on the current URL containing '/sites/view/'
 */
const isEditView = () => window.location.href.includes('/sites/view/');

export const isAutoMountingReactApp = !!(modifyRegistration && updatingRegistrationActive);

/** @var {Promise} */
let formRequest = null;

const populateBootstrapData = (store) => {
    const COLOR_PALETTE = get(window.splash, 'server.constants.activeColorSwatch', '');
    const COLOR_PALETTES = get(window.splash, 'server.constants.colorSwatches', []);
    const FONT_GROUP = get(window.splash, 'server._event.theme_styles.selected_font_combo', '');
    const EVENT_ID = get(window.splash, 'server._event.id', '').toString();
    const { edit, effective } = window.splash.server._event.domain;
    const isUserLoggedIn = !!get(window, 'splash.server._user.id');
    const isRegistrationOpen = window.splash.server._event.rsvp_status === 'open';

    // File upload must use whatever the page used.
    // That way, for Splash pages using a vanity URL with HTTP, it'll work as expected.
    const FILE_UPLOAD_URL = `${getProtocol()}//${isEditView() ? edit : effective}`;

    // @TODO, get this from bootstrap data from the back-end.
    const FORM_SUBMIT_URL = window.location.href.replace(window.location.search, '');

    const colors = parseColorsFromCmsBootstrapFormat(COLOR_PALETTE, COLOR_PALETTES);
    const fonts = parseFontsFromCmsBootstrapFormat(FONT_GROUP);

    store.dispatch(
        loadBootstrapData({
            uploadUrl: FILE_UPLOAD_URL,
            submitUrl: FORM_SUBMIT_URL,
            eventSubdomain: EVENT_SUBDOMAIN,
            fonts,
            colors,
            eventId: EVENT_ID,
            guestAccessHash,
            isAutoMountingReactApp,
            viewerData,
            updatingRegistrationActive,
            modifyRegistration,
            isInsideEditingFrame,
            limitOneOrderPerEmail,
            limitOneTicketTypePerEmail,
            isUserLoggedIn,
            isRegistrationOpen,
            isUnpublished,
        }),
    );
};

const getFormRendererFetcher = (formPreviewId) =>
    isAutoMountingReactApp
        ? () =>
              fetchFilledFormRenderer({
                  clientId: CLIENT_ID,
                  clientSecret: CLIENT_SECRET,
                  baseUrl: baseApiUrl,
                  guestAccessHash,
                  isFormSessionRegistrationFlagEnabled,
              })
        : () => fetchFormRenderer(isFormSessionRegistrationFlagEnabled, formPreviewId);

export default (store, formPreviewId) => {
    if (!formRequest) {
        populateBootstrapData(store);

        const formRendererFetcher = getFormRendererFetcher(formPreviewId);

        formRequest = store.dispatch(formRendererFetcher());
    }
    return formRequest;
};

export const loadUpdateResponses = (store) => {
    const state = store.getState();
    const guestAccessHashAfterRsvp = getGuestAccessHash(state);

    if (!guestAccessHashAfterRsvp) {
        store.dispatch(fetchFormRenderer());
    } else {
        store.dispatch(setIsUpdating(true));

        store.dispatch(
            fetchFilledFormRenderer({
                clientId: CLIENT_ID,
                clientSecret: CLIENT_SECRET,
                baseUrl: baseApiUrl,
                guestAccessHash: guestAccessHashAfterRsvp,
            }),
        );
    }

    store.dispatch(openModal());
};
